export default __webpack_public_path__ + "static/media/adnan_ahmed.1a7d7c52.png";